import { useI18n } from "vue-i18n";
import { computed } from "vue";

export const useLocaleMapping = () => {
    const { locale } = useI18n();
    const defaultLocale = "nl-BE";
    const mapping = {
        en: "en-GB",
        fr: "fr-BE",
        nl: "nl-BE",
    };

    const mappedLocale = computed(() => {
        if (!locale.value) return defaultLocale;
        if (mapping[locale.value]) return mapping[locale.value];
        return locale.value;
    });

    return {
        mappedLocale,
    };
};
